import { publicUrl } from "./config";

export const RADAR_SLUGS = ["tech", "ai"] as const;
export type RadarSlug = (typeof RADAR_SLUGS)[number];

export type RadarDescriptor = {
  slug: RadarSlug;
  name: string; // page title and hero headline
  shortName: string; // title used by the home cards and the footer
  navLabel: string; // long label, used in prose
  switchLabel: string; // short label of the header switcher
  tagline: string; // paragraph used by the home cards
  accent: string; // brand colour identifying the radar
};

export const RADARS: Record<RadarSlug, RadarDescriptor> = {
  tech: {
    slug: "tech",
    name: "Elyadata Technology Radar",
    shortName: "Technology Radar",
    navLabel: "Tech Radar",
    switchLabel: "Tech",
    accent: "var(--logo-cyan)",
    tagline:
      "Languages, data platforms, engineering practices and delivery patterns. The stack behind our data pipelines, web systems and client integrations.",
  },
  ai: {
    slug: "ai",
    name: "Elyadata AI Radar",
    shortName: "AI Radar",
    navLabel: "AI Radar",
    switchLabel: "AI",
    accent: "var(--logo-magenta)",
    tagline:
      "Foundation models, training and evaluation frameworks, MLOps platforms and application patterns — including our work on low-resource languages and Tunisian Arabic speech.",
  },
};

export const DEFAULT_RADAR: RadarSlug = "tech";

export const isRadarSlug = (s: string): s is RadarSlug =>
  (RADAR_SLUGS as readonly string[]).includes(s);

export const radarDataUrl = (slug: RadarSlug, file: string) =>
  `${publicUrl}data/${slug}/${file}`;
